"use server";

import { State } from "@/types/form";
import { _getClientToken, verifyServerSession } from "@/utils/auth";

export const updateUserPasswordCompliance = async (
  isCompliant: boolean,
): Promise<State> => {
  const { loggedInUuid } = await verifyServerSession();
  const token = await _getClientToken();

  // First get all existings attributes to merge them with the passwordPolicyCompliant attribute
  const getUserResponse = await fetch(
    `${process.env.KEYCLOACK_ADMIN_URL}/users/${loggedInUuid}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token.access_token}`,
      },
    },
  );

  if (!getUserResponse.ok) {
    return {
      status: getUserResponse.status,
      message: "Failed to fetch user data",
    };
  }

  const userData = await getUserResponse.json();
  const existingAttributes = userData.attributes || {};

  const rep = await fetch(
    `${process.env.KEYCLOACK_ADMIN_URL}/users/${loggedInUuid}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token.access_token}`,
      },
      body: JSON.stringify({
        ...userData,
        attributes: {
          ...existingAttributes,
          passwordPolicyCompliant: [isCompliant.toString()],
        },
      }),
    },
  );

  return {
    status: rep.status,
    message: rep.statusText,
  };
};
